import type { ReportingTreeResponse } from "@/lib/contactsDirectoryClient";

export function resolveUserManagerProfileFromExternalNode(
  startNode: NonNullable<ReportingTreeResponse["nodes"]>[number] | undefined,
  externalDirectoryById: Map<string, { email: string | null }>,
  orgProfileIdByEmail: Map<string, string>,
  reportingNodeByKey: Map<string, NonNullable<ReportingTreeResponse["nodes"]>[number]>,
  normalizeEmail: (value: string | null | undefined) => string
): string | null {
  if (!startNode || startNode.source !== "external") return null;
  const visited = new Set<string>();
  let cursor: NonNullable<ReportingTreeResponse["nodes"]>[number] | undefined = startNode;
  while (cursor && cursor.source === "external" && !visited.has(cursor.key)) {
    visited.add(cursor.key);
    if (cursor.reports_to_profile_id) return cursor.reports_to_profile_id;
    const extRow = externalDirectoryById.get(cursor.row_id);
    const extEmail = normalizeEmail(extRow?.email);
    if (extEmail) {
      const byEmail = orgProfileIdByEmail.get(extEmail);
      if (byEmail) return byEmail;
    }
    if (!cursor.reports_to_external_id) break;
    cursor = reportingNodeByKey.get(`external:${cursor.reports_to_external_id}`);
  }
  return null;
}
